export default "__VITE_ASSET__YEnD3hQK__"